import { getLaunchPlanStatus } from "./api.js";

/**
 * The founding-client offer (handoff.md section 1.6) applies uniformly
 * across Launch/Growth/Pro - same remaining-slot count, same 50% off setup.
 * /v1/launch-plan/status only returns Launch's own dollar figures, but its
 * remainingFoundingSlots count is tier-agnostic (it reads the same live
 * nova_clients founding count/limit regardless of which tier a visitor is
 * looking at) - each tier card's own founding price is pre-computed in the
 * markup (data-standard-setup / data-founding-setup) from the same 50%
 * figure quoted everywhere else on this page, so this script only needs the
 * live count, not a second per-tier API surface.
 *
 * Per the source handoff: hide the founding box entirely on 0 remaining
 * slots or on fetch failure - the static page never claims a number it
 * can't back up.
 */
async function loadFoundingStatus(): Promise<void> {
  const box = document.querySelector<HTMLElement>("#founding-box");
  const text = document.querySelector<HTMLElement>("#founding-box-text");
  if (!box || !text) return;
  try {
    const status = await getLaunchPlanStatus();
    if (status.remainingFoundingSlots <= 0) return;
    text.textContent = `Founding-client offer: 50% off setup for the first 3 clients (Lawrence-area preferred). ${status.remainingFoundingSlots} slot${status.remainingFoundingSlots === 1 ? "" : "s"} remaining.`;
    box.hidden = false;
    document.querySelectorAll<HTMLElement>("[data-tier-setup]").forEach((element) => {
      const standard = element.dataset.standardSetup;
      const founding = element.dataset.foundingSetup;
      if (!standard || !founding) return;
      element.innerHTML = `<s>$${Number(standard).toLocaleString()}</s> <span class="founding-price">$${Number(founding).toLocaleString()} setup (founding)</span>`;
    });
  } catch {
    // Launch-plan tracking isn't configured in this environment - keep the static standard-price copy already in the markup.
  }
}
void loadFoundingStatus();
